module.exports = __webpack_public_path__ + "img/manage-friends.e90e4cdc.svg";